import React from "react";
import { useHistory, useParams } from "react-router";
import styled from "styled-components";

const CustomHomePage2 = (): React.ReactElement => {
  let history = useHistory();
  const { study_slug } = useParams<{ study_slug: string }>();

  const handleVisitSite = () => {
    window.open("https://www.tabapsy.fr", "_blank");
  };

  const handleAccessQuestionnaires = () => {
    history.push(`/${study_slug}/resonance/sequences`);
  };

  return (
    <ScrollableContainer>
      <ContentWrapper>
        <HeaderSection>
          <Title>Bienvenue à Tabapsy</Title>
          <Subtitle>L'étude dédiée à la consommation de tabac.</Subtitle>
        </HeaderSection>

        <Section>
          <Paragraph>
            La durée de votre participation à l'étude est de 6 mois. Pendant
            cette période, nous vous solliciterons 3 fois pour remplir le même
            questionnaire.
          </Paragraph>

          <ActionCard>
            <Paragraph>Pour accéder aux questionnaires :</Paragraph>
            <ButtonContainer>
              <StyledButton onClick={handleAccessQuestionnaires}>
                Commencez à répondre aux questionnaires
              </StyledButton>
            </ButtonContainer>
          </ActionCard>

          <ThankYouMessage>
            <HeartIcon>❤️</HeartIcon>
            Encore merci pour votre contribution à cette recherche !
          </ThankYouMessage>
        </Section>
      </ContentWrapper>
    </ScrollableContainer>
  );
};

const ScrollableContainer = styled.div`
  height: 100vh;
  overflow-y: auto;
  background-color: rgb(255, 255, 255);
  padding: 0px 20px 250px;
`;

const ContentWrapper = styled.div`
  max-width: 800px;
  margin: 0 auto 40px auto;
  padding: 19px;
  background: #ffffff;
  border-radius: 16px;
  // box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
`;

const HeaderSection = styled.div`
  text-align: center;
  margin-bottom: 40px;
  padding-bottom: 30px;
  border-bottom: 2px solid #cdebf3;
`;

const Title = styled.h1`
  font-size: 2.4rem;
  color: rgb(57 57 57);
  margin-bottom: 16px;
  font-weight: 700;
  margin-top: 0px;
`;

const Subtitle = styled.h2`
  font-size: 1.2rem;
  color: #4a5568;
  font-weight: 400;
`;

const Section = styled.div`
  margin-bottom: 30px;
`;

const Paragraph = styled.p`
  font-size: 1.1rem;
  line-height: 1.7;
  margin-bottom: 24px;
  margin-top: 0px;
  color: #2d3748;
`;

const ActionCard = styled.div`
  background: rgb(205 235 243 / 15%);
  padding: 15px;
  border-radius: 12px;
  margin: 30px 0;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 24px 0;
`;

const StyledButton = styled.button<{ primary?: boolean }>`
    display: inline-flex;
    align-items: center;
    padding: 18px 35px;
    font-size: 1.1rem;
    font-weight: 600;
    color: ${({ primary }) => primary ? 'white' : '#2a4365'};
    background: ${({ primary }) => 
        primary ? 'linear-gradient(135deg, #2b6cb0 0%, #3182ce 100%)' : '#cdebf3'};
    border: none;
    border-radius: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    gap: 10px;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
        background: ${({ primary }) => 
            primary ? 'linear-gradient(135deg, #2c5282 0%, #2b6cb0 100%)' : '#b3e5fc'};
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
`;

const CallToAction = styled.div`
  text-align: center;
  margin: 40px 0;
  padding: 32px;
  background: linear-gradient(to right, #ebf8ff, #e6fffa);
  border-radius: 12px;
`;

const ThankYouMessage = styled.div`
    text-align: center;
    font-size: 1.2rem;
    color: #2a4365;
    font-weight: 500;
    margin-top: 60px;
    padding: 30px 0;
    border-top: 2px solid rgba(205, 235, 243, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
`;

const ButtonIcon = styled.span`
  margin-left: 8px;
  display: flex;
  align-items: center;
`;

const HeartIcon = styled.span`
  font-size: 1.4rem;
  animation: pulse 1.2s infinite;

  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  }
`;

export default CustomHomePage2;
